import { useCallback } from "react";
import { stringify } from "query-string";
import { ApiRoutes } from "../../../constants/apiRoutes";
import { useApi } from "../../../hooks/useApi";

export default function () {
  const { request } = useApi();

  return {
    fetchByCountry: useCallback(
      async (filter) => {
        return request({
          method: "GET",
          url: `${ApiRoutes.GET_STATISTICS_BY_COUNTRY + stringify(filter)}`,
          shouldHandleError: true,
        });
      },
      [request],
    ),

    fetchByEducationType: useCallback(
      async (filter) => {
        return request({
          method: "GET",
          url: `${
            ApiRoutes.GET_STATISTICS_BY_EDUCATION_TYPE + stringify(filter)
          }`,
          shouldHandleError: true,
        });
      },
      [request],
    ),
  };
}
